import { API_ROUTES, request } from './instance';
import { UserRolesEnum } from '@shared';

// swagger https://qa-auditor.proctorfree.com/swagger-ui/#/api-auth-controller

type LoginResponseAPI = {
  id: number;
  name: string;
  roles: Array<UserRolesEnum>;
  partnerUUIDs: string[];
};

export const login = ({ email, password }: LoginPayload) => {
  return request<LoginResponseAPI>({
    url: `${API_ROUTES.login()}`,
    method: 'POST',
    data: { username: email, password },
  });
};

export const verification = ({ code }: VerificationPayload) => {
  return request({
    url: `${API_ROUTES.verification()}`,
    method: 'POST',
    data: { code },
  });
};

export const logout = () => {
  return request({
    url: `${API_ROUTES.logout()}`,
    method: 'POST',
  });
};

export type LoginPayload = {
  email: string;
  password: string;
};

export type VerificationPayload = {
  code: string;
};

declare global {
  interface Window {
    logout: () => Promise<unknown>;
  }
}
if (process.env.NODE_ENV === 'development') {
  window.logout = logout;
}
